import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
  Table,
} from "reactstrap";
import { useSafariPaymentReset } from "../../../hooks/useSafariPaymentReset";
import CustomInput from "../../../custom/CustomInput";
import CustomSelect from "../../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CircularIndeterminate from "../../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";
import Branch2025 from "../../../assets/Branch2025.pdf";
import LinerLoader from "../../../components/loader/LinearProgress";

const BengaluruEnrollment = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  const { courses } = useSelector((state) => state.courses);
  const { branches } = useSelector((state) => state.branches);
  const { level } = useSelector((state) => state.level);
  const { weekDays } = useSelector((state) => state.weekDays);

  const { courseByEvents, isLoading } = useSelector(
    (state) => state.courseByEvents
  );
  const filteredCourses = courseByEvents.sort(
    (a, b) => a.priority - b.priority
  );

  const data = {
    id: "62",
  };
  useEffect(() => {
    // dispatch(actions.coursesGetData());
    dispatch(actions.courseByEventsGetData(data));
    dispatch(actions.batchesGetData());
    dispatch(actions.branchesGetData());
    dispatch(actions.levelGetData());
    dispatch(actions.weekDaysGetData());
  }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      branch_id: values.branch_id,
      course_id: values.course_id,
      week_days_id: values.week_days_id,
      level_id: values.level_id,
      day_1: values.day_1,
      time_day_1: values.time_day_1,
      day_2: values.day_2,
      time_day_2: values.time_day_2,
      day_3: values.day_3,
      time_day_3: values.time_day_3,
      day_4: values.day_4,
      time_day_4: values.time_day_4,
      day_5: values.day_5,
      time_day_5: values.time_day_5,
      day_6: values.day_6,
      time_day_6: values.time_day_6,
      totalfees: values.totalfees,
      clientname: values.clientname,
      parent_name: values.parent_name,
      gender: values.gender,
      dob: values.dob,
      building_name: values.building_name,
      area: values.area,
      streat_area: values.streat_area,
      city: values.city,
      pincode: values.pincode,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      month: values.month,
      is_enquiry: values.is_enquiry,
      is_online_payment: values.is_online_payment,
    };
    // iOS Safari compatible redirect
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, resetForm)
    );
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  branch_id: "",
                  course_id: "",
                  week_days_id: "",
                  level_id: "",
                  day_1: "",
                  time_day_1: "",
                  day_2: "",
                  time_day_2: "",
                  day_3: "",
                  time_day_3: "",
                  day_4: "",
                  time_day_4: "",
                  day_5: "",
                  time_day_5: "",
                  day_6: "",
                  time_day_6: "",
                  clientname: "",
                  parent_name: "",
                  gender: "",
                  dob: "",
                  building_name: "",
                  area: "",
                  streat_area: "",
                  city: "",
                  pincode: "",
                  clientemail: "",
                  clientphone: "",
                  is_enquiry: "0",
                  is_online_payment: "1",
                  // test
                  monthly_fee: "",
                  reg_fee: "",
                  activity_fee: "",
                  sub_total: "",
                  exact_sub_total: "",
                  gst: "",
                  month: "",
                  // grand_total: "",
                  totalfees: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                  course_id: Yup.string().required("required"),
                  week_days_id: Yup.string().required("required"),
                  level_id: Yup.string().required("required"),
                  month: Yup.string().required("required"),
                })}
              >
                {(formProps) => {
                  const total = formProps.values.totalfees;
                  const defaultProps = {
                    options: filteredCourses?.filter(
                      (itm) => itm.branch_id == formProps.values.branch_id
                    ),

                    getOptionLabel: (option) => option.name,
                  };

                  // const levelProps = {
                  //   options: level
                  //     .sort((a, b) => parseFloat(a.id) - parseFloat(b.id))
                  //     ?.filter(
                  //       (i) =>
                  //         formProps.values.course_id == i.course_id &&
                  //         i.month_wise_fees == formProps.values.month
                  //     ),
                  //   getOptionLabel: (option) => option.level_type,
                  // };
                  const levelProps = {
                    options: level
                      .sort((a, b) => parseFloat(a.id) - parseFloat(b.id))
                      ?.filter(
                        (i) =>
                          formProps.values.course_id == i.course_id &&
                          i.month_wise_fees == formProps.values.month
                      ),
                    getOptionLabel: (option) => {
                      if (!option) return "";
                      if (typeof option === "string") return option;
                      return option.level_type || "";
                    },
                  };
                  return (
                    <Form className="mt-3">
                      {console.log("formProps", formProps.values)}
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="branch_id" className="label">
                            Your Venue:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="branch_id"
                              id="branch_id"
                              className={
                                "form-control" +
                                (formProps.errors.branch_id &&
                                formProps.touched.branch_id
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>
                                -- Select Your Venue --
                              </option>
                              {branches.length > 0 &&
                                branches
                                  ?.filter((itm) => itm?.address == "Benguluru")
                                  .map((itm) => {
                                    return (
                                      <option value={itm.id}>{itm.name}</option>
                                    );
                                  })}
                            </Field>
                            <ErrorMessage
                              name="branch_id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {isLoading ? (
                        <div className="p-3">
                          <LinerLoader />
                        </div>
                      ) : (
                        <Row className="form-group">
                          <Col md={12} className="mt-2">
                            <Label htmlFor="course_id" className="label">
                              Your Course:
                            </Label>
                            <InputGroup>
                              <Autocomplete
                                {...defaultProps}
                                id="course_id"
                                name="course_id"
                                getOptionSelected={(option, value) =>
                                  option.id === value.id
                                }
                                onChange={(event, newValue) => {
                                  console.log("new", newValue);
                                  formProps.setFieldValue(
                                    `course_id`,
                                    newValue?.id ?? ""
                                  );
                                }}
                                sx={{ width: "100%" }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Course Name *"
                                    variant="outlined"
                                    name="course_id"
                                    size="small"
                                    className="form-control"
                                    error={
                                      formProps.touched.course_id &&
                                      Boolean(formProps.errors.course_id)
                                    }
                                    helperText={
                                      formProps.touched.course_id &&
                                      formProps.errors.course_id
                                    }
                                  />
                                )}
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      )}
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="month" className="label">
                            Select Your Months/Months Of Fees.
                          </Label><br/>
                          <small>Select More Months For More Discounts</small>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="month"
                              id="month"
                              className={
                                "form-control" +
                                (formProps.errors.month &&
                                formProps.touched.month
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={(e) => {
                                formProps.handleChange(e);
                                formProps.setFieldValue("level_id", "");

                                formProps.setFieldValue("monthly_fee", "");
                                formProps.setFieldValue("reg_fee", "");
                                formProps.setFieldValue("activity_fee", "");
                                formProps.setFieldValue("sub_total", "");
                                formProps.setFieldValue("exact_sub_total", "");
                                formProps.setFieldValue("gst", "");
                                formProps.setFieldValue("totalfees", "");
                              }}
                            >
                              <option value={""}>
                                -- Select Your Months/Months Of Fees --
                              </option>
                              <option value={"1"}>1 Month</option>
                              <option value={"3"}>3 Months</option>
                              <option value={"6"}>6 Months</option>
                              <option value={"9"}>9 Months</option>
                              <option value={"12"}>12 Months</option>
                            </Field>
                            <ErrorMessage
                              name="month"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="level_id" className="label">
                            Choose Your Level:
                          </Label>
                          <InputGroup>
                            <Autocomplete
                              {...levelProps}
                              id="level_id"
                              name="level_id"
                              getOptionSelected={(option, value) =>
                                option.id === value.id
                              }
                              value={
                                levelProps.options.find(
                                  (opt) => opt.id === formProps.values.level_id
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                console.log("new", newValue);
                                formProps.setFieldValue(
                                  `level_id`,
                                  newValue?.id ?? ""
                                );
                                formProps.setFieldValue(
                                  `monthly_fee`,
                                  newValue?.monthly_fee ?? ""
                                );
                                formProps.setFieldValue(
                                  `reg_fee`,
                                  newValue?.reg_fee ?? ""
                                );
                                formProps.setFieldValue(
                                  `activity_fee`,
                                  newValue?.activity_fee ?? ""
                                );
                                formProps.setFieldValue(
                                  `sub_total`,
                                  newValue?.sub_total ?? ""
                                );
                                formProps.setFieldValue(
                                  `exact_sub_total`,
                                  newValue?.exact_sub_total ?? ""
                                );
                                formProps.setFieldValue(
                                  `gst`,
                                  newValue?.gst ?? ""
                                );
                                formProps.setFieldValue(
                                  `totalfees`,
                                  newValue?.grand_total ?? ""
                                );
                                // week_days_id
                                formProps.setFieldValue(
                                  `week_days_id`,
                                  newValue?.week_days_id ?? ""
                                );
                              }}
                              sx={{ width: "100%" }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Choose Your Level *"
                                  variant="outlined"
                                  name="level_id"
                                  size="small"
                                  className="form-control"
                                  error={
                                    formProps.touched.level_id &&
                                    Boolean(formProps.errors.level_id)
                                  }
                                  helperText={
                                    formProps.touched.level_id &&
                                    formProps.errors.level_id
                                  }
                                />
                              )}
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="week_days_id" className="label">
                            Your Week Days:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="week_days_id"
                              id="week_days_id"
                              placeholder="Enter Week Days"
                              className={
                                "form-control" +
                                (formProps.errors.week_days_id &&
                                formProps.touched.week_days_id
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option>-- Select Class Duration --</option>
                              {weekDays?.map((itm) => {
                                if (itm.id == "10")
                                  return (
                                    <option value={itm.id}>{itm.name}</option>
                                  );
                              })}
                            </Field>
                            <ErrorMessage
                              name="week_days_id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {/* once a week */}
                      {formProps.values.week_days_id == "11" ? (
                        <Row className="form-group">
                          <Col md={6} className="mt-2">
                            <Label htmlFor="day_1" className="label">
                              Choose Your Day 1 :
                            </Label>
                            <InputGroup>
                              <Field
                                component={CustomSelect}
                                type="select"
                                name="day_1"
                                id="day_1"
                                className={
                                  "form-control" +
                                  (formProps.errors.day_1 &&
                                  formProps.touched.day_1
                                    ? " is-invalid"
                                    : "")
                                }
                              >
                                <option>-- Select --</option>
                                <option value={"Sunday"}>Sunday</option>
                                <option value={"Monday"}>Monday</option>
                                <option value={"Tuesday"}>Tuesday</option>
                                <option value={"Wednesday"}>Wednesday</option>
                                <option value={"Thursday"}>Thursday</option>
                                <option value={"Friday"}>Friday</option>
                                <option value={"Saturday"}>Saturday</option>
                              </Field>
                              <ErrorMessage
                                name="day_1"
                                component="div"
                                className="invalid-feedback"
                              />
                            </InputGroup>
                          </Col>
                          <Col md={6} className="mt-2">
                            <Label htmlFor="time_day_1" className="label">
                              Your Time for Day 1:
                            </Label>
                            <InputGroup>
                              <Field
                                component={CustomInput}
                                type="time"
                                name="time_day_1"
                                id="time_day_1"
                                placeholder="Enter Week Days"
                                className={
                                  "form-control" +
                                  (formProps.errors.time_day_1 &&
                                  formProps.touched.time_day_1
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="time_day_1"
                                component="div"
                                className="invalid-feedback"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                      {/* twise a week  */}
                      {formProps.values.week_days_id == "10" ? (
                        <>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_1" className="label">
                                Choose Your Day 1 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_1"
                                  id="day_1"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_1 &&
                                    formProps.touched.day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_1" className="label">
                                Your Time for Day 1:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_1"
                                  id="time_day_1"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_1 &&
                                    formProps.touched.time_day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_2" className="label">
                                Choose Your Day 2 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_2"
                                  id="day_2"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_2 &&
                                    formProps.touched.day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_2" className="label">
                                Your Time for Day 2:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_2"
                                  id="time_day_2"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_2 &&
                                    formProps.touched.time_day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}
                      {/* 3 a week  */}
                      {formProps.values.week_days_id == "9" ? (
                        <>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_1" className="label">
                                Choose Your Day 1 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_1"
                                  id="day_1"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_1 &&
                                    formProps.touched.day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_1" className="label">
                                Your Time for Day 1:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_1"
                                  id="time_day_1"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_1 &&
                                    formProps.touched.time_day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_2" className="label">
                                Choose Your Day 2 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_2"
                                  id="day_2"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_2 &&
                                    formProps.touched.day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_2" className="label">
                                Your Time for Day 2:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_2"
                                  id="time_day_2"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_2 &&
                                    formProps.touched.time_day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_3" className="label">
                                Choose Your Day 3 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_3"
                                  id="day_3"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_3 &&
                                    formProps.touched.day_3
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_3"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_3" className="label">
                                Your Time for Day 3:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_3"
                                  id="time_day_3"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_3 &&
                                    formProps.touched.time_day_3
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_3"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}
                      {/* 4 a week  */}
                      {formProps.values.week_days_id == "8" ? (
                        <>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_1" className="label">
                                Choose Your Day 1 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_1"
                                  id="day_1"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_1 &&
                                    formProps.touched.day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_1" className="label">
                                Your Time for Day 1:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_1"
                                  id="time_day_1"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_1 &&
                                    formProps.touched.time_day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_2" className="label">
                                Choose Your Day 2 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_2"
                                  id="day_2"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_2 &&
                                    formProps.touched.day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_2" className="label">
                                Your Time for Day 2:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_2"
                                  id="time_day_2"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_2 &&
                                    formProps.touched.time_day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_3" className="label">
                                Choose Your Day 3 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_3"
                                  id="day_3"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_3 &&
                                    formProps.touched.day_3
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_3"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_3" className="label">
                                Your Time for Day 3:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_3"
                                  id="time_day_3"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_3 &&
                                    formProps.touched.time_day_3
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_3"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_4" className="label">
                                Choose Your Day 4 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_4"
                                  id="day_4"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_4 &&
                                    formProps.touched.day_4
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_4"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_4" className="label">
                                Your Time for Day 4:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_4"
                                  id="time_day_4"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_4 &&
                                    formProps.touched.time_day_4
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_4"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}
                      {/* 5 a week  */}
                      {formProps.values.week_days_id == "7" ? (
                        <>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_1" className="label">
                                Choose Your Day 1 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_1"
                                  id="day_1"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_1 &&
                                    formProps.touched.day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_1" className="label">
                                Your Time for Day 1:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_1"
                                  id="time_day_1"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_1 &&
                                    formProps.touched.time_day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_2" className="label">
                                Choose Your Day 2 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_2"
                                  id="day_2"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_2 &&
                                    formProps.touched.day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_2" className="label">
                                Your Time for Day 2:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_2"
                                  id="time_day_2"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_2 &&
                                    formProps.touched.time_day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_3" className="label">
                                Choose Your Day 3 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_3"
                                  id="day_3"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_3 &&
                                    formProps.touched.day_3
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_3"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_3" className="label">
                                Your Time for Day 3:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_3"
                                  id="time_day_3"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_3 &&
                                    formProps.touched.time_day_3
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_3"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_4" className="label">
                                Choose Your Day 4 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_4"
                                  id="day_4"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_4 &&
                                    formProps.touched.day_4
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_4"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_4" className="label">
                                Your Time for Day 4:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_4"
                                  id="time_day_4"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_4 &&
                                    formProps.touched.time_day_4
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_4"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_5" className="label">
                                Choose Your Day 5 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_5"
                                  id="day_5"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_5 &&
                                    formProps.touched.day_5
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_5"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_5" className="label">
                                Your Time for Day 5:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_5"
                                  id="time_day_5"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_5 &&
                                    formProps.touched.time_day_5
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_5"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}
                      {/* 6 a week  */}
                      {formProps.values.week_days_id == "6" ? (
                        <>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_1" className="label">
                                Choose Your Day 1 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_1"
                                  id="day_1"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_1 &&
                                    formProps.touched.day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_1" className="label">
                                Your Time for Day 1:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_1"
                                  id="time_day_1"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_1 &&
                                    formProps.touched.time_day_1
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_2" className="label">
                                Choose Your Day 2 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_2"
                                  id="day_2"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_2 &&
                                    formProps.touched.day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <Label htmlFor="time_day_2" className="label">
                                Your Time for Day 2:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_2"
                                  id="time_day_2"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_2 &&
                                    formProps.touched.time_day_2
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_3" className="label">
                                Choose Your Day 3 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_3"
                                  id="day_3"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_3 &&
                                    formProps.touched.day_3
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_3"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_3" className="label">
                                Your Time for Day 3:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_3"
                                  id="time_day_3"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_3 &&
                                    formProps.touched.time_day_3
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_3"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_4" className="label">
                                Choose Your Day 4 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_4"
                                  id="day_4"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_4 &&
                                    formProps.touched.day_4
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_4"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_4" className="label">
                                Your Time for Day 4:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_4"
                                  id="time_day_4"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_4 &&
                                    formProps.touched.time_day_4
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_4"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_5" className="label">
                                Choose Your Day 5 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_5"
                                  id="day_5"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_5 &&
                                    formProps.touched.day_5
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_5"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_5" className="label">
                                Your Time for Day 5:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_5"
                                  id="time_day_5"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_5 &&
                                    formProps.touched.time_day_5
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_5"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="day_6" className="label">
                                Choose Your Day 6 :
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomSelect}
                                  type="select"
                                  name="day_6"
                                  id="day_6"
                                  className={
                                    "form-control" +
                                    (formProps.errors.day_6 &&
                                    formProps.touched.day_6
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option>-- Select --</option>
                                  <option value={"Sunday"}>Sunday</option>
                                  <option value={"Monday"}>Monday</option>
                                  <option value={"Tuesday"}>Tuesday</option>
                                  <option value={"Wednesday"}>Wednesday</option>
                                  <option value={"Thursday"}>Thursday</option>
                                  <option value={"Friday"}>Friday</option>
                                  <option value={"Saturday"}>Saturday</option>
                                </Field>
                                <ErrorMessage
                                  name="day_6"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                            <Col md={6} className="mt-3">
                              <Label htmlFor="time_day_6" className="label">
                                Your Time for Day 6:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="time"
                                  name="time_day_6"
                                  id="time_day_6"
                                  placeholder="Enter Week Days"
                                  className={
                                    "form-control" +
                                    (formProps.errors.time_day_6 &&
                                    formProps.touched.time_day_6
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="time_day_6"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}
                      {/* fee structure */}
                      {formProps.values.level_id !== "" ? (
                        <Row className="mt-3">
                          <Col md={10}>
                            <Label className="mt-3 mb-3 text-orange">
                              FEE STRUCTURE:
                            </Label>
                            <Table bordered>
                              <thead>
                                <tr>
                                  <th>Fees Type</th>
                                  <th>Amount [In INR]</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th scope="row" rowSpan={2}>
                                    Monthly Fee:
                                  </th>
                                  <td>
                                    Select Months:
                                    <select>
                                      <option>1</option>
                                    </select>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">
                                    {formProps.values.monthly_fee} [{" "}
                                    {formProps.values.monthly_fee} per month]
                                  </th>
                                </tr>
                                <tr>
                                  <td>Registration Fee:</td>
                                  <td>
                                    {formProps.values.reg_fee} [to be paid one
                                    time ]
                                  </td>
                                </tr>
                                <tr>
                                  <td>Activity Fee:</td>
                                  <td>
                                    {formProps.values.activity_fee} [to be paid
                                    one time ]
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">Sub Total [In INR] :</th>
                                  <th scope="row">
                                    {formProps.values.sub_total}
                                  </th>
                                </tr>
                                <tr>
                                  <th scope="row">
                                    Exact Sub Total [In INR] for Member Count 1:
                                  </th>
                                  <th scope="row">
                                    {formProps.values.exact_sub_total}
                                  </th>
                                </tr>
                                <tr>
                                  <td>GST [ 18% on Sub Total in INR]:</td>
                                  <td>{formProps.values.gst}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Grand Total:</th>
                                  <th scope="row">
                                    INR <input value={total} readOnly />
                                  </th>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      ) : null}

                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="clientname" className="label">
                            Your Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="parent_name" className="label">
                            Your Parent Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="parent_name"
                              id="parent_name"
                              placeholder="Enter Your Parent Name"
                              className={
                                "form-control" +
                                (formProps.errors.parent_name &&
                                formProps.touched.parent_name
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="parent_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="gender" className="label">
                            Your Gender:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="gender"
                              id="gender"
                              placeholder="Enter Your Gender"
                              className={
                                "form-control" +
                                (formProps.errors.gender &&
                                formProps.touched.gender
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Gender</option>
                              <option value={"Male"}>Male</option>
                              <option value={"Female"}>Female</option>
                            </Field>
                            <ErrorMessage
                              name="gender"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="dob" className="label">
                            Your Date Of Birth :
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="date"
                              name="dob"
                              id="dob"
                              // placeholder="Enter Your Date Of Birth"
                              className={
                                "form-control" +
                                (formProps.errors.dob && formProps.touched.dob
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="dob"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="building_name" className="label">
                            Your Flat no. and Building Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="textarea"
                              name="building_name"
                              id="building_name"
                              placeholder="Enter Your Flat no. and Building Name"
                              className={
                                "form-control" +
                                (formProps.errors.building_name &&
                                formProps.touched.building_name
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="building_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {/* <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="area" className="label">
                            Your Address Area, Location Details:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="textarea"
                              name="area"
                              id="area"
                              placeholder="Enter Your Address Area, Location Details"
                              className={
                                "form-control" +
                                (formProps.errors.area && formProps.touched.area
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="area"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="streat_area" className="label">
                            Your Address Street Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="textarea"
                              name="streat_area"
                              id="streat_area"
                              placeholder="Enter Your Address Street Name"
                              className={
                                "form-control" +
                                (formProps.errors.streat_area &&
                                formProps.touched.streat_area
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="streat_area"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row> */}
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="city" className="label">
                            Your City:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="city"
                              id="city"
                              placeholder="Enter Your Residence City"
                              className={
                                "form-control" +
                                (formProps.errors.city && formProps.touched.city
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="pincode" className="label">
                            Your Pincode:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="pincode"
                              id="pincode"
                              placeholder="Enter Your Pincode"
                              className={
                                "form-control" +
                                (formProps.errors.pincode &&
                                formProps.touched.pincode
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="pincode"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="clientemail" className="label">
                            Your Email:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientemail"
                              id="clientemail"
                              placeholder="Enter Your Email"
                              className={
                                "form-control" +
                                (formProps.errors.clientemail &&
                                formProps.touched.clientemail
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientemail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="clientphone" className="label">
                            Your Mobile:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Mobile"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={6}>
                          <InputGroup>
                            <Field type="checkbox" name="checked" value="One" />

                            <span className="radiobtn-test">
                              {" "}
                              &nbsp;
                              <a href={Branch2025} target="_blank">
                                Please Accept Terms & Condition
                              </a>
                            </span>
                            <ErrorMessage
                              name="branch"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <div className="mt-3 mb-3 row">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? (
                              <CircularIndeterminate />
                            ) : (
                              "PAY NOW"
                            )}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default BengaluruEnrollment;
